import React, { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/css';
import Asset from './Asset';
import { debounce, get, invoke, floor, clamp, range } from 'lodash';
import { isMobileScreen } from '../../utils/utils';
import PropTypes from 'prop-types';

const listStyle = css`
  display: flex;
  justify-content: end;
`;

const assetContainerStyle = css`
  width: 5rem;
  height: 5rem;
  margin-left: 0.25rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7b1a27;

  @media (max-width: 641px) {
    width: 3rem;
    height: 3rem;
  }
`;

const assetCardContainer = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  align-items: end;
  width: 100%;
`;

const OrderAssetList = (props) => {
  const products = get(props, 'products', []);
  const loading = get(props, 'loading', false);
  const containerRef = useRef(null);
  const [maxProducts, setMaxProducts] = useState(7);
  const additionalItems = products && products.length - maxProducts;

  const handleWindowResize = debounce(
    () => {
      if (loading) return;

      const containerBounds = invoke(containerRef, 'current.getBoundingClientRect');

      const assetSize = isMobileScreen() ? 48 : 80;
      const max = isMobileScreen() ? 4 : 7;

      const maxProducts: number = clamp(floor(get(containerBounds, 'width') / assetSize) - 1, 1, max) as number;

      setMaxProducts(maxProducts);
    },
    100,
    { leading: true },
  );

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    handleWindowResize();

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const assetList = products.slice(0, maxProducts).map((product) => (
    <div
      className={assetContainerStyle}
      data-testid="product"
      id={`asset_${get(product, 'productBpn')}`}
      key={`asset_${get(product, 'productBpn')}`}
    >
      <Asset productBpc={get(product, 'productBpn')} loading={false} />
    </div>
  ));
  const moreItemsText = additionalItems > 0 ? `+${additionalItems}` : '';

  return (
    <div className={assetCardContainer} ref={containerRef}>
      <div className={listStyle}>
        {loading
          ? range(5).map((a) => (
              <div className={assetContainerStyle} data-testid="product" id={`asset_${a}`} key={`asset_${a}`}>
                <Asset productBpc={`${a}`} loading={true} />
              </div>
            ))
          : assetList}
        {additionalItems > 0 ? (
          <div
            className={assetContainerStyle}
            tabIndex={0}
            aria-label={`Product graphic ${moreItemsText}`}
            aria-roledescription="icon"
          >
            {moreItemsText}
          </div>
        ) : null}
      </div>
    </div>
  );
};

OrderAssetList.propTypes = {
  products: PropTypes.array,
  loading: PropTypes.bool,
};

export default OrderAssetList;
